/* ================================================== */
/* Scripts ========================================== */
/* ================================================== */

const $ = require('jquery');
// const google_maps = require('./google-maps.js');

require('@popperjs/core');
require('bootstrap');
require('slick-carousel');
require('magnific-popup');

window.jQuery = $;

$(function () {
  container_fix();
  // google_maps.init_google_maps();
  magnific_init();
  mega_menu();
  slick_init();
  usps_offset();

  /* Automatically updates path names for local development */
  // if (window.location.hostname === 'local_site_name.test' || window.location.hostname === 'localhost') {
  //   universal_path_change('local_site_name', 'pressable_site_name');
  // }

  /* Applies the "active" class to hyperlinks within the header */
  // $("header .nav [href]").each(function () {
  //   if (this.href == window.location.href) { $(this).addClass("active"); }
  // }); 

  /* Handles resize events */
  $(window).on("resize", function () { 
    container_fix(); 
    mega_menu(); 
    usps_offset();
  });

  /* Enables smooth scrolling on hyperlinks tagged with "smooth" class */
  $('a.smooth[href*="#"]').on("click", function (event) {
    if (location.pathname.replace(/^\//, "") == this.pathname.replace(/^\//, "") && location.hostname == this.hostname) {
      var target = $(this.hash);
      var offset = $("header").outerHeight();
      target = target.length ? target : $("[name=" + this.hash.slice(1) + "]");
      if (target.length) { event.preventDefault(); $("html, body").animate({ scrollTop: target.offset().top - offset }, 1000); }
    }
  });

  /* Handles vanilla submenu behaviour */
  $(".toggle").on("click", function () {
    var toggle = $(this);
    toggle.toggleClass("open");
    $(this).prev(".parent").toggleClass("open");
    var submenu = $(this).next(".submenu");
    submenu.children("ul").slideToggle("fast");
  });

  /* Triggering the burger menu upon click */
  $("#burger").on('click', function () {
    open = !open;
    menu_toggle(open);
  });

  /* Triggering the basket tray upon click */
  $(".basket-tray-trigger").on('click', function () {
    open = !open;
    basket_tray(open);
  });
  $('#basket-underlay').on('click', function () {
    open = !open;
    basket_tray(open);
  });

  /* Triggering the filter wrappers */
  $('.filter-wrapper > button').on('click', function(e) {
    e.preventDefault();

    const $thisWrapper = $(this).closest('.filter-wrapper');
    const $thisInner = $thisWrapper.find('.filter-inner');

    // Close all other filter wrappers
    $('.filter-wrapper').not($thisWrapper).removeClass('open').find('.filter-inner').slideUp(200);

    // Toggle the clicked one
    $thisInner.slideToggle(200);
    $thisWrapper.toggleClass('open');
  });

  $('#mobile-filter-trigger').on('click', function(e) {
    e.preventDefault();

    const $thisWrapper = $(this).closest('.button-wrapper');

    $('.mobile-filter-inner').slideToggle(200);
    $thisWrapper.toggleClass('open');
  });

  /* Mobile clear filters */
  // $('.filter-clear').on('click', function(e) {
  //   e.preventDefault();
  //   const targetId = $(this).data('ref');
  //   const $input = $('#' + targetId);
  //   if ($input.length) {
  //     $input.trigger('click');
  //   }
  // });
  $('.filter-clear').on('click', function(e) {
    e.preventDefault();

    const targetId = $(this).data('ref'); // e.g. "roast-level_123"
    if (!targetId) return;

    const $input = $('#' + targetId);
    if ($input.length) {
      $input.trigger('click');
      $('#apply-filters').trigger('click');
    } else {
      console.warn('No input found with ID:', targetId);
    }
  });
});

/**
 * @name usps_offset
 * @description sets the top value on the USPs bar (if applicable)
**/

let usps_offset = () => {
  if ($("#feature-usps").length) {
    let offset = $("#header").outerHeight();
    $("#feature-usps").css('top', offset + 'px');
  }
}

/**
 * @name check_scroll
 * @description checks the scroll value of the window and adds a class to the header if the window is scrolled
**/
let check_scroll = () => {
  let scroll = $(window).scrollTop();
  if (scroll > 0) {
    $("header").addClass("scroll");
  } else {
    $("header").removeClass("scroll");
  }
};

/**
 * @name container_fix
 * @description function for fixing floating elements or page width elements with content to the conventional Bootstrap container sizes
**/
let container_fix = () => {
  if ($('.container-fix').length) {
    let containerWidths = {
      576: 540,
      768: 720,
      992: 960,
      1200: 1140,
      1440: 1440,
    };
    let windowWidth = $(window).width();
    let containerWidth = 0;
    for (const [key, value] of Object.entries(containerWidths)) {
      if (windowWidth >= key) {
        containerWidth = value;
      }
    }

    var padding = ((windowWidth - containerWidth) / 2) + 32;
    if (windowWidth >= 992) {
      $('.container-fix').each(function () {
        if ($(this).hasClass('odd')) {
          $(this).css('padding-left', '0px');
          $(this).css('padding-right', padding + 'px');
        } else if ($(this).hasClass('even')) {
          $(this).css('padding-left', padding + 'px');
          $(this).css('padding-right', '0px');
        }
      });
    } else if (windowWidth >= 576 && windowWidth <= 991) {
      $('.container-fix').each(function () {
        $(this).css('padding-left', padding + 'px');
        $(this).css('padding-right', padding + 'px');
      });
    } else {
      $('.container-fix').each(function () {
        $(this).css('padding-left', '32px');
        $(this).css('padding-right', '32px');
      });
    }
  }
};

/**
 * @name magnific_init
 * @description initialise the Magnific Popups for the page
**/
let magnific_init = () => {
  $('.magnific').magnificPopup({
    type:'image',
    gallery: {
      enabled: true,
    }
  });
};

/**
 * @name mega_menu
 * @description handles the offset for mega menus
**/
let mega_menu = () => {
  if ($('.mega-menu').length) {
    setTimeout(function() {
      let header_height = $('#header').outerHeight();
      $('.mega-menu').css('top', header_height + 'px');
    }, 500);
  }
}

/**
 * @name menu_toggle
 * @description handles opening and closing of the mobile menu on the site
 * @param {*} open flag indicating whether or not the menu is in an open state
**/
var open = false;
let menu_toggle = (open) => {
  $("#burger").toggleClass("open", open);
  $("#navigation-mobile").toggleClass("triggered", open);
  $("#navigation-mobile > .menu-inner").toggleClass("open", open);
};

/**
 * @name basket_tray
 * @description handles opening and closing of the basket tray
 * @param {*} open flag indicating whether or not the tray is in an open state
**/
let basket_tray = (open) => {
  $("#basket-tray").toggleClass("open", open);
};

/**
 * @name slick_init
 * @description initialise the Slick sliders for the page (docs: https://kenwheeler.github.io/slick/)
**/
let slick_init = () => {
  $(".carousel-usps").slick({
    arrows: false,
    autoplay: true,
    autoplaySpeed: 3000,
    dots: false,
    infinite: true,
    mobileFirst: true,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 2,
        }
      },
    ],
    slidesToScroll: 1,
    slidesToShow: 1,
  });

  $(".carousel-icons").slick({
    arrows: false,
    autoplay: true,
    autoplaySpeed: 3000,
    dots: false,
    infinite: true,
    mobileFirst: true,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 2,
        }
      },
    ],
    slidesToScroll: 1,
    slidesToShow: 1,
  });

  $(".carousel-testimonials").slick({
    dots: true,
    infinite: true,
    mobileFirst: true,
    nextArrow: '<button class="slick-arrow slick-next"><img alt="Next" src="/wp-content/uploads/2025/04/right.png"></button>',
    prevArrow: '<button class="slick-arrow slick-prev"><img alt="Prev" src="/wp-content/uploads/2025/04/left.png"></button>',
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 1199,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 3,
        }
      },
    ],
    slidesToScroll: 1,
    slidesToShow: 1,
  });
};

/**
 * @name universal_path_change
 * @description update paths appropriately during development
 */
let universal_path_change = (liveDomain, localDomain) => {
  const live = liveDomain;
  const local = localDomain;

  // Replace domain in <img> src attributes
  $('img').each(function () {
    const currentSrc = $(this).attr('src');

    // Update test domain
    if (currentSrc && currentSrc.includes(local + '.test')) {
      $(this).attr('src', currentSrc.replace(local + '.test', live + '.mystagingwebsite.com'));
    }

    // Update local domain
    if (currentSrc && currentSrc.includes('localhost:3000')) {
      $(this).attr('src', currentSrc.replace('localhost:3000', live + '.mystagingwebsite.com'));
    }
  });

  // Replace domain in <video> src attributes
  $('video').each(function () {
    const currentSrc = $(this).attr('src');
    const currentPoster = $(this).attr('poster');

    // Update test domain
    if (currentSrc && currentSrc.includes(local + '.test')) {
      $(this).attr('src', currentSrc.replace(local + '.test', live + '.mystagingwebsite.com'));
    }

    if (currentPoster && currentPoster.includes(local + '.test')) {
      $(this).attr('poster', currentPoster.replace(local + '.test', live + '.mystagingwebsite.com'));
    }

    // Update local domain
    if (currentSrc && currentSrc.includes('localhost:3000')) {
      $(this).attr('src', currentSrc.replace('localhost:3000', live + '.mystagingwebsite.com'));
    }

    if (currentPoster && currentPoster.includes('localhost:3000')) {
      $(this).attr('poster', currentPoster.replace('localhost:3000', live + '.mystagingwebsite.com'));
    }
  });

  // Replace domain in <div> background-image style attributes
  $('div').each(function () {
    const currentBg = $(this).css('background-image');

    // Update test domain
    if (currentBg && currentBg.includes(local + '.test')) {
      const updatedBg = currentBg.replace(local + '.test', live + '.mystagingwebsite.com');
      $(this).css('background-image', updatedBg);
    }

    // Update local domain
    if (currentBg && currentBg.includes('localhost:3000')) {
      const updatedBg = currentBg.replace('localhost:3000', live + '.mystagingwebsite.com');
      $(this).css('background-image', updatedBg);
    }
  });

  // Replace domain in <a> src attributes
  $('a').each(function () {
    const currentSrc = $(this).attr('href');

    // Update test domain
    if (currentSrc && currentSrc.includes(live + '.mystagingwebsite.com') && window.location.hostname === local + '.test') {
      $(this).attr('href', currentSrc.replace(live + '.mystagingwebsite.com', local + '.test'));
    }

    // Update test domain
    if (currentSrc && currentSrc.includes(live + '.mystagingwebsite.com') && window.location.hostname === 'localhost') {
      $(this).attr('href', currentSrc.replace(live + '.mystagingwebsite.com', 'localhost:3000'));
    }
  });
};